import React from "react";

function usePrevious<T>(value: T) {
  const ref = React.useRef<T>();
  React.useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

export function useNonNullablePrevious<T>(value: T) {
  const ref = React.useRef<T>();
  React.useEffect(() => {
    if (value !== null && value !== undefined) {
      ref.current = value;
    }
  }, [value]);
  return ref.current;
}

export default usePrevious;
